import React from "react";

const NemaPodataka = () => {
  return <>Nema unetih podataka</>;
};

export default NemaPodataka;
